import { IconX } from '@tabler/icons-react';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
// import { Modal } from 'react-bootstrap';

const ConfirmationModal = ({ buttonComponent, onConfirm, confirmationText }) => {
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const submit = () => {
        onConfirm();
        handleClose();
    }

    return (
        <>
            <div className="cursor-pointer" onClick={handleShow}>
                {buttonComponent}
            </div>
            <Modal show={show} onHide={handleClose} className='confirmation-modal !z-[1056]' >
                <Modal.Body className='rounded-xl'>
                    <div className="flex justify-between items-center">
                        <p className="text-md font-semibold">Confirmation!!</p>
                        <IconX className='cursor-pointer' onClick={handleClose} />
                    </div>
                    <hr className='my-3' />
                    <p className="text-sm">{confirmationText}</p>
                    <hr className='my-3' />
                    <div className='flex justify-end gap-3'>
                        <button className='cancel-btn' onClick={handleClose}>Cancel</button>
                        <button className='primary-btn' onClick={() => submit()}>Yes</button>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ConfirmationModal